// src/config/routes.ts
import Home from '../pages/index';
import Users from '../pages/Users';
import CodeIndexDetailsPage from '../pages/CodeIndexDetailsPage';
import UnderConstruction from '../pages/UnderConstruction';
import Roles from '../pages/Roles';
import ErrorPage from '../pages/ErrorPage';
import NotFound from '../pages/NotFound';


export interface RouteConfig {
  path: string;
  name: string;
  icon?: string;
  component: React.ComponentType<any>;
  children?: RouteConfig[];
}

export const routes: RouteConfig[] = [
  {
    path: '/',
    name: 'Code Index',
    icon: 'bi-house',
    component: Home
    // children: [
    //   {
    //     path: '/home',
    //     name: 'RequestList',
    //     component: Home
    //   }
    // ]
  },

  {
    path: '*',
    name: 'NotFound',
    icon: 'bi-x',
    component: NotFound
  },
  {
    path: '/users',
    name: 'Users',
    icon: 'bi-people',
    component: Users
  },
  {
    path: '/roles',
    name: 'roles',
    icon: 'bi-collection',
    component: Roles
  },
  {
    path: '/details/:id',
    name: 'details',
    icon: 'bi-list',
    component: CodeIndexDetailsPage
  },
  {
    path: '/under-construction',
    name: 'Under Construction',
    icon: 'bi-tools',
    component: UnderConstruction
  },
  {
    path: '/error',
    name: 'Error',
    icon: 'bi-exclamation',
    component: ErrorPage
  },
  // {
  //   path: '/details/:appname',
  //   name: 'Details',
  //   icon: 'bi-house',
  //   component: Details,
    
  // },
  //  {
  //   path: '/users',
  //   name: 'Users',
  //   icon: 'bi-house',
  //   component: Users,
    
  // },

];

export default routes; 